import { ISearchRepository } from "@/repositories/search";
import { ISearchService } from "./search.types";

export class SearchService implements ISearchService {
    constructor(private repository: ISearchRepository) {}

    async autoComplete(keyword: string): Promise<string[]> {
        return (await this.repository.autoComplete(keyword));
    }

    async search(keyword: string): Promise<any[]> {
        return (await this.repository.search(keyword));
    }
    
    // async createSale(userData: ISaleData): Promise<ISale> {
    //     return (await this.repository.create(userData));
    // }

    // async syncSale(userData: ISaleData): Promise<ISale> {
    //     const user = await this.getSaleById(userData.id as string);
    //     if(user){
    //         return user;
    //     }
    //     return await this.createSale(userData);
    // }
}
